import { TextFieldProps } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import cs from 'date-fns/locale/cs';
import { Control, Controller } from 'react-hook-form';
import { useErrorMessageResolver } from '../../localization/useErrorMessageResolver';

type FormDatePickerProps = {
  control: Control<any>;
  name: string;
  textFieldProps?: Partial<Omit<TextFieldProps, 'name'>>;
  readonly?: boolean;
} & Omit<DatePickerProps<any>, 'name' | 'inputRef' | 'renderInput' | 'onChange' | 'value'>;
export const FormDatePicker = ({ control, name, textFieldProps, readonly, ...textProps }: FormDatePickerProps) => {
  const resolveErrorMessage = useErrorMessageResolver();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, value, onChange, ...fieldRest }, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={cs}>
          <DatePicker
            {...textProps}
            {...fieldRest}
            readOnly={readonly ?? textFieldProps?.InputProps?.readOnly}
            value={new Date(value ?? '')}
            onChange={(e) => {
              onChange(e?.toISOString());
            }}
            inputRef={ref}
            slotProps={{
              textField: {
                ...textFieldProps,
                fullWidth: true,
                error: !!error,
                helperText: resolveErrorMessage(error?.message),
                variant: readonly ? 'standard' : textFieldProps?.variant,
                InputProps: {
                  ...textFieldProps?.InputProps,
                  readOnly: readonly ?? textFieldProps?.InputProps?.readOnly,
                  disableUnderline: readonly ?? textFieldProps?.InputProps?.readOnly,
                },
              },
            }}
          />
        </LocalizationProvider>
      )}
    />
  );
};
